import { render, staticRenderFns } from "./ConsignacaoMenu.vue?vue&type=template&id=14998f03&scoped=true&"
import script from "./ConsignacaoMenu.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoMenu.vue?vue&type=script&lang=js&"
import style0 from "./ConsignacaoMenu.vue?vue&type=style&index=0&id=14998f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14998f03",
  null
  
)

export default component.exports